import React from 'react';
import Box from '@mui/material/Box';
import Masonry from '@mui/lab/Masonry';

export default class MasonryList extends React.Component{

    constructor(props) {
        super(props);

        this.state = {
            itemData: this.props.itemData,
            lenght: this.props.itemData.lenght
        }
    }

    componentDidUpdate(prevProps, prevState) {
       
        if (this.props.itemData !== prevProps.itemData) {

            this.setState({
                itemData: this.props.itemData,
                lenght: this.props.itemData.lenght
            })
        }        
    }

    render() {

        let masonry = <Box className="r_masonryList" sx={{ width: "100%", height: "90%" }}>
            <Masonry
                columns={2}
                spacing={1}
                defaultHeight={6000}
                defaultColumns={2}
                defaultSpacing={1}>
                {this.state.itemData}
            </Masonry>
        </Box>
                
        return (
            <>
                {masonry}
            </>
        );
    }
}